module.exports = __webpack_public_path__ + "static/media/Group49.aaab3383.svg";